import { ChevronDownIcon } from "@heroicons/react/24/solid";
import React from "react";
import { useTranslation } from "react-i18next";

const FormSelectBox = ({
  label,
  name,
  value,
  onChange,
  options,
  required = false,
  error,
  placeholder,
  icon = null,
  additionalClass = "",
  hideEmptySelection = false,
}) => {
  const { t } = useTranslation();

  return (
    <div className="mb-4">
      <label className="block text-sm font-medium">
        {label}{" "}
        {required && <span className="text-muted">{t("modal.required")}</span>}
        {!required && <span className="text-muted">{t("modal.optional")}</span>}
      </label>
      <div className="relative">
        {icon && (
          <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-500 pointer-events-none">
            {icon}
          </span>
        )}
        <select
          name={name}
          value={value}
          onChange={(e) => onChange(name, e.target.value)}
          required={required}
          className={`appearance-none w-full border ${
            error ? "border-red-500" : "border-gray-300"
          } rounded-lg px-4 py-3 h-[50px] ${
            icon ? "pl-10" : ""
          } pr-10 focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary ${additionalClass}`}
        >
          {!hideEmptySelection && <option value="">{placeholder}</option>}

          {options.map((option) => (
            <option key={option.id} value={option.id}>
              {option.name}
            </option>
          ))}
        </select>

        {/* FLECHE CUSTOM */}
        <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-gray-500">
          <ChevronDownIcon className="w-5 h-5 text-gray-500"></ChevronDownIcon>
        </div>
      </div>
      {error && <p className="text-sm text-red-500">{error}</p>}
    </div>
  );
};

export default FormSelectBox;
